import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import BASE_URL from "../BaseUrl/apiConfig";

const UpdateThreadMessageLogModal = ({
  showModal,
  setShowModal,
  type: initialType,
  recipientName: initialRecipientName,
  recipientEmailOrLink: initialRecipientEmailOrLink,
  startDate: initialStartDate,
  messageStatus: initialMessageStatus,
  message: initialMessage,
  description: initialDescription,
  selectedMessageLog,
  updateData,
  resetForm,
  threadId,
}) => {
  const [type, setType] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmailOrLink, setRecipientEmailOrLink] = useState("");
  const [ccEmail, setCcEmail] = useState(""); // New state for CC email
  const [startDate, setStartDate] = useState(new Date());
  const [messageStatus, setMessageStatus] = useState("");
  const [message, setMessage] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [senderEmail, setSenderEmail] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [emailOptions, setEmailOptions] = useState([]);
  const [threadMessageID, setThreadMessageID] = useState(null);

  useEffect(() => {
    if (showModal) {
      setErrors({});
      if (selectedMessageLog) {
        // Existing message log being edited
        setType(selectedMessageLog.type || "Email");
        setRecipientName(selectedMessageLog.recipientName || "");
        setRecipientEmailOrLink(selectedMessageLog.recipientEmailOrLink || "");
        setCcEmail(selectedMessageLog.ccEmail || "");
        setStartDate(new Date(selectedMessageLog.messageDate) || new Date());
        setMessageStatus(selectedMessageLog.messageStatus || "New");
        setMessage(selectedMessageLog.message || "");
        setDescription(selectedMessageLog.description || "");
        setSenderEmail(selectedMessageLog.senderEmail || "");
        setThreadMessageID(selectedMessageLog.threadMessageID || null);
      } else {
        // Adding a new message log
        setType(initialType || "Email");
        setRecipientName(""); // Clear name for new entries
        setRecipientEmailOrLink(""); // Clear email for new entries
        setCcEmail("");
        setStartDate(initialStartDate || new Date());
        setMessageStatus(initialMessageStatus || "New");
        setMessage(initialMessage || "");
        setDescription(initialDescription || "");
        setSenderEmail(selectedMessageLog.senderEmail || "");
        setThreadMessageID(null);
      }
    }
  }, [
    showModal,
    selectedMessageLog,
    initialType,
    initialRecipientName,
    initialRecipientEmailOrLink,
    initialStartDate,
    initialMessageStatus,
    initialMessage,
    initialDescription,
  ]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setIsConfirmed(checked);
    } else {
      switch (name) {
        case "type":
          setType(value);
          if (value !== "Email") {
            setCcEmail(""); // Clear CC email field when type changes
            setDescription("");
            setIsConfirmed(false);
          }
          break;
        case "recipientName":
          setRecipientName(value);
          break;
        case "recipientEmailOrLink":
          setRecipientEmailOrLink(value);
          // Skip individual email validation; just ensure it's not empty
          if (!value) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              recipientEmailOrLink: "Recipient Email field cannot be empty",
            }));
          } else {
            setErrors((prevErrors) => ({
              ...prevErrors,
              recipientEmailOrLink: null,
            }));
          }
          break;
        case "ccEmail":
          setCcEmail(value);
          // Remove validation for at least two CC email addresses
          setErrors((prevErrors) => ({
            ...prevErrors,
            ccEmail: null,
          }));
          break;
        case "messageStatus":
          setMessageStatus(value);
          break;
        case "senderEmail":
          setSenderEmail(value);
          break;
        case "description":
          setDescription(value);
          break;
        default:
          break;
      }
    }
  };

  const validateFields = () => {
    const newErrors = {};

    if (!type) newErrors.type = "Type is required";
    if (!recipientName) newErrors.recipientName = "Recipient Name is required";

    // Ensure recipient email field is not empty
    if (!recipientEmailOrLink) {
      newErrors.recipientEmailOrLink =
        "Recipient Email 'or' Profile Links are required";
    }

    if (!startDate) newErrors.messageDate = "Message Date is required";

    const messageString = typeof message === "string" ? message : "";
    if (messageString.trim() === "<p><br></p>" || messageString.trim() === "") {
      newErrors.message = "Message content is required";
    }

    if (!messageStatus) newErrors.messageStatus = "Message Status is required";

    if (type === "Email") {
      if (isConfirmed && !senderEmail) {
        newErrors.senderEmail = "Sender Email is required if confirmed";
      }
      if (!description) {
        newErrors.description = "Subject is required for Email type";
      }
    }

    // Removed the check for at least two CC email addresses

    return newErrors; // Return the newErrors object
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const handleMessageChange = (value) => {
    setMessage(value);
  };

  // const validateFields = () => {
  //   const newErrors = {};
  //   if (!type) newErrors.type = "Type is required";
  //   if (!recipientName) newErrors.recipientName = "Recipient Name is required";
  //   if (!recipientEmailOrLink) {
  //     newErrors.recipientEmailOrLink =
  //       "Recipient Email 'or' Profile Links are required";
  //   } else if (type === "Email") {
  //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //     if (!emailRegex.test(recipientEmailOrLink)) {
  //       newErrors.recipientEmailOrLink = "Invalid email address";
  //     }
  //   }

  //   if (ccEmail) {
  //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //     if (!emailRegex.test(ccEmail)) {
  //       newErrors.ccEmail = "Invalid CC email address";
  //     }
  //   }

  //   if (!startDate) newErrors.messageDate = "Message Date is required";

  //   // Ensure message is a string before checking its content
  //   const messageString = typeof message === "string" ? message : "";
  //   if (messageString.trim() === "<p><br></p>" || messageString.trim() === "") {
  //     newErrors.message = "Message content is required";
  //   }

  //   if (!messageStatus) newErrors.messageStatus = "Message Status is required";
  //   if (type === "Email") {
  //     if (isConfirmed && !senderEmail) {
  //       newErrors.senderEmail = "Sender Email is required if confirmed";
  //     }
  //     if (!description)
  //       newErrors.description = "Subject is required for Email type";
  //   }

  //   // `description` is optional
  //   return newErrors; // Return the newErrors object
  // };

  useEffect(() => {
    const fetchEmailOptions = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const groupId = userData ? userData.groupId : null;

        if (groupId === null) {
          throw new Error("Group ID is not available in local storage");
        }

        const response = await fetch(
          `${BASE_URL}/api/Expense/GetAllEmailSMTPForDD?GroupID=${groupId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setEmailOptions(data);
      } catch (error) {
        console.error("Error fetching email options:", error);
      }
    };

    fetchEmailOptions();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = validateFields();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const userData = JSON.parse(localStorage.getItem("userData"));

    // Retrieve messageId from local storage
    const messageId = localStorage.getItem("messageId");
    // Construct the payload
    const payload = {
      recipientEmailOrLink: recipientEmailOrLink,
      ccEmail,
      subject: description,
      body: message,
      senderEmail: senderEmail,
      type,
      recipientName,
      messageDate: startDate.toISOString(),
      messageStatus,
      message,
      description,
      userId: userData.userId,
      groupId: userData.groupId,
      createdOn: new Date().toISOString(),
      ...(threadMessageID && { threadMessageID }),
      ...(messageId && { messageID: messageId }),
      ...(selectedMessageLog && { messageID: selectedMessageLog.messageID }),
    };

    // Include messageId if it exists in local storage
    if (messageId) {
      payload.messageID = messageId;
    }

    // Include messageID from selectedMessageLog for updates
    if (selectedMessageLog) {
      payload.messageID = selectedMessageLog.messageID;
    }

    try {
      // Check if email needs to be sent and type is "Email"
      if (isConfirmed && type === "Email") {
        // Display confirmation dialog
        const { value: confirmed } = await Swal.fire({
          title: "Confirm Email Sending",
          text: `Are you sure you want to send this email using ${senderEmail}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, send it!",
          cancelButtonText: "No, cancel",
        });

        // Proceed only if confirmed
        if (confirmed) {
          const emailResponse = await fetch(
            `${BASE_URL}/api/Expense/SendThreadEmail`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );

          if (!emailResponse.ok) {
            throw new Error("Failed to send email");
          }

          Swal.fire("Success", "Email has been sent successfully.", "success");
        } else {
          // If not confirmed, exit the function
          return;
        }
      }

      // Send the payload to the API
      const response = await fetch(
        `${BASE_URL}/api/Expense/AddUpdateThreadMessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("An error occurred while saving the Thread message.");
      }

      const data = await response.json();
      Swal.fire(
        "Success",
        selectedMessageLog
          ? "Message has been updated successfully."
          : "Message has been added successfully.",
        "success"
      );

      handleCloseModal();
      fetchMessageLogs();
      updateData();
      resetForm();
    } catch (error) {
      console.error("Error:", error);
      Swal.fire(
        "Error",
        "An error occurred while saving the Thread message.",
        "error"
      );
    }
  };

  const fetchMessageLogs = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData ? userData.groupId : null;

    fetch(`${BASE_URL}/api/Expense/GetAllMesaageLog?UserID=${groupId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // setMessageLogs(data);
        updateData();
        setErrors("");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleCloseModal = () => {
    setShowModal(false);
    fetchMessageLogs();
    resetForm();
  };

  return (
    <>
      {showModal && (
        <>
          <div className="fixed inset-0 bg-gray-900 opacity-50 z-50"></div>
          <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg rounded-lg p-8 z-50">
            <h2 className="text-xl font-bold mb-4">Update Message Log</h2>
            <form onSubmit={handleSubmit} className="row">
              {/* Your form fields here */}
              <div className="form-group col-6 col-lg-2 mb-4">
                <select
                  className={`form-control custom-height ${
                    errors.type ? "is-invalid" : ""
                  }`}
                  name="type"
                  value={type}
                  onChange={handleInputChange}
                  title="Select the message type"
                >
                  <option value="">Select Type</option>
                  <option value="Email">Email</option>
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Others">Others</option>
                </select>
                {errors.type && (
                  <div className="text-red-500">{errors.type}</div>
                )}
              </div>

              <div className="form-group col-6 col-lg-3 mb-4">
                <input
                  type="text"
                  name="recipientName"
                  placeholder="Recipient Name"
                  value={recipientName}
                  onChange={handleInputChange}
                  className={`form-control custom-height ${
                    errors.recipientName ? "is-invalid" : ""
                  }`}
                  title="Enter the recipient's name"
                />
                {errors.recipientName && (
                  <div className="text-red-500">{errors.recipientName}</div>
                )}
              </div>

              <div className="form-group col-12 col-lg-4 mb-4">
                <input
                  type="text"
                  name="recipientEmailOrLink"
                  placeholder="Recipient Email 'or' Profile Links"
                  value={recipientEmailOrLink}
                  onChange={handleInputChange}
                  className={`form-control custom-height ${
                    errors.recipientEmailOrLink ? "is-invalid" : ""
                  }`}
                  title="Enter the recipient's email or profile link"
                />
                {errors.recipientEmailOrLink && (
                  <div className="text-red-500">
                    {errors.recipientEmailOrLink}
                  </div>
                )}
              </div>

              <div className="form-group col-6 col-lg-3 mb-4">
                <input
                  type="text"
                  name="ccEmail"
                  placeholder="CC Email"
                  value={ccEmail}
                  onChange={handleInputChange}
                  className={`form-control custom-height ${
                    errors.ccEmail ? "is-invalid" : ""
                  }`}
                  title="Enter CC email addresses"
                  disabled={type !== "Email"}
                />
                {errors.ccEmail && (
                  <div className="text-red-500">{errors.ccEmail}</div>
                )}
              </div>
              {type === "Email" && (
                <>
                  <div className="form-group col-12 col-lg-10 mb-4">
                    <textarea
                      name="description"
                      placeholder="Subject"
                      value={description}
                      onChange={handleInputChange}
                      className={`form-control custom-height ${
                        errors.description ? "is-invalid" : ""
                      }`}
                      title="Enter a Subject of Mail"
                    />
                    {errors.description && (
                      <div className="text-red-500">{errors.description}</div>
                    )}
                  </div>
                </>
              )}

              <div className="form-group col-6 col-lg-2 mb-4">
                <DatePicker
                  selected={startDate}
                  onChange={handleDateChange}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="dd/MM/yyyy HH:mm"
                  className={`form-control custom-height ${
                    errors.messageDate ? "is-invalid" : ""
                  }`}
                  popperPlacement="bottom" // Always open below the input field
                  popperModifiers={{
                    preventOverflow: {
                      enabled: false, // Disable preventOverflow to avoid repositioning
                    },
                    hide: {
                      enabled: false, // Disable hide to ensure visibility
                    },
                  }}
                  title="Select date and time"
                />
                {errors.messageDate && (
                  <div className="text-red-500">{errors.messageDate}</div>
                )}
              </div>

              <div className="form-group col-12 col-lg-12 mb-4">
                <ReactQuill
                  value={message}
                  onChange={handleMessageChange}
                  placeholder="Message"
                  className={`custom-height ${
                    errors.message ? "is-invalid" : ""
                  }`}
                  title="Enter the message content"
                  style={{
                    border: "1px solid #ddd",
                    minHeight: "200px",
                    maxHeight: "200px",
                    overflow: "auto",
                  }}
                />
                {errors.message && (
                  <div className="text-red-500">{errors.message}</div>
                )}
              </div>
              {type === "Email" && (
                <>
                  <div className="form-group col-6 col-lg-3 mb-4">
                    <select
                      className={`form-control custom-height ${
                        errors.senderEmail ? "is-invalid" : ""
                      }`}
                      name="senderEmail"
                      value={senderEmail}
                      onChange={handleInputChange}
                      title="Select Sender Email"
                    >
                      <option value="">Select Sender Email</option>
                      {emailOptions.map((option) => (
                        <option
                          key={option.settingID}
                          value={option.senderEmail}
                        >
                          {option.senderEmail}
                        </option>
                      ))}
                    </select>
                    {errors.senderEmail && (
                      <div className="text-red-500">{errors.senderEmail}</div>
                    )}
                  </div>
                  <div className="form-group col-6   mb-4 flex items-center justify-end mb-4 ">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        id="confirmationCheckbox"
                        name="confirmationCheckbox"
                        checked={isConfirmed}
                        onChange={handleInputChange}
                        className={`form-check-input ${
                          errors.confirmationCheckbox ? "is-invalid" : ""
                        }`}
                      />
                      <label
                        htmlFor="confirmationCheckbox"
                        className="form-check-label"
                      >
                        Please confirm that you wish to send this Email to
                        Recipient Email address.
                      </label>
                      {errors.confirmationCheckbox && (
                        <div className="text-red-500">
                          {errors.confirmationCheckbox}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="flex justify-end mt-4">
                <button
                  type="button"
                  className="bg-orange-500 text-white text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg focus:outline-none"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-lightblue-500 text-white text-xs font-bold uppercase px-4 py-2 ml-2 rounded shadow hover:shadow-lg focus:outline-none custom-button"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  );
};

export default UpdateThreadMessageLogModal;
